import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    /* Black */
    ---max-color-black: ${({ theme }) => theme.colors.black};
    ---max-color-black: ${({ theme }) => theme.colors.black};
    ---max-color-black80: ${({ theme }) => theme.colors.black80};
    ---max-color-black70: ${({ theme }) => theme.colors.black70};
    ---max-color-black60: ${({ theme }) => theme.colors.black60};
    ---max-color-black40: ${({ theme }) => theme.colors.black40};
    ---max-color-black20: ${({ theme }) => theme.colors.black20};

    /* Gray */
    ---max-color-gray4: ${({ theme }) => theme.colors.gray4};
    ---max-color-gray3: ${({ theme }) => theme.colors.gray3};
    ---max-color-gray2: ${({ theme }) => theme.colors.gray2};
    ---max-color-gray1: ${({ theme }) => theme.colors.gray1};

    /* Navy */
    ---max-color-navy: ${({ theme }) => theme.colors.navy};
    ---max-color-navy80: ${({ theme }) => theme.colors.navy80};
    ---max-color-navy60: ${({ theme }) => theme.colors.navy60};
    ---max-color-navy40: ${({ theme }) => theme.colors.navy40};
    ---max-color-navy20: ${({ theme }) => theme.colors.navy20};
    ---max-color-navy10: ${({ theme }) => theme.colors.navy10};

    /* Blue */
    ---max-color-blue: ${({ theme }) => theme.colors.blue};
    ---max-color-blue80: ${({ theme }) => theme.colors.blue80};
    ---max-color-blue60: ${({ theme }) => theme.colors.blue60};
    ---max-color-blue40: ${({ theme }) => theme.colors.blue40};
    ---max-color-blue20: ${({ theme }) => theme.colors.blue20};
    ---max-color-blue10: ${({ theme }) => theme.colors.blue10};

    /* Green */
    ---max-color-green: ${({ theme }) => theme.colors.green};
    ---max-color-green80: ${({ theme }) => theme.colors.green80};
    ---max-color-green60: ${({ theme }) => theme.colors.green60};
    ---max-color-green40: ${({ theme }) => theme.colors.green40};
    ---max-color-green20: ${({ theme }) => theme.colors.green20};
    ---max-color-green10: ${({ theme }) => theme.colors.green10};

    /* Yellow */
    ---max-color-yellow: ${({ theme }) => theme.colors.yellow};
    ---max-color-yellow80: ${({ theme }) => theme.colors.yellow80};
    ---max-color-yellow60: ${({ theme }) => theme.colors.yellow60};
    ---max-color-yellow40: ${({ theme }) => theme.colors.yellow40};
    ---max-color-yellow20: ${({ theme }) => theme.colors.yellow20};
    ---max-color-yellow10: ${({ theme }) => theme.colors.yellow10};

    /* Red */
    ---max-color-red: ${({ theme }) => theme.colors.red};
    ---max-color-red80: ${({ theme }) => theme.colors.red80};
    ---max-color-red60: ${({ theme }) => theme.colors.red60};
    ---max-color-red40: ${({ theme }) => theme.colors.red40};
    ---max-color-red20: ${({ theme }) => theme.colors.red20};
    ---max-color-red10: ${({ theme }) => theme.colors.red10};
  }
  body {
    margin: 0;
    padding: 0;
    font-family: Poppins;
  }
`;

export default GlobalStyle;
